import * as yup from 'yup';

const regSchema = yup.object().shape({
  ctgovRadio: yup.string().required('A star rating is required...'),
  ctgovTextArea: yup.string(),
  e707a74c: yup.string().oneOf([""]),
  o34b5832: yup.string().oneOf(["8bc152e2-ab12-4da5-b74a-d848522c3bf9"]),
  
});

export { regSchema };